import DOMPurify from "dompurify";

/**
 * Sanitizes Knowledge Base article HTML before it is injected via
 * dangerouslySetInnerHTML (Feature 4317). The API also sanitizes on write
 * (sanitize.ArticleContent, bluemonday), so this is defense-in-depth on the
 * render path: it strips scripts, event handlers, and other active content while
 * preserving the formatting, links, and embedded screenshots authors use.
 *
 * Relative image src (e.g. /help-articles/images/<uuid>) and absolute http(s)
 * src are both preserved by DOMPurify's defaults; call this AFTER rewriting
 * image URLs so the final attributes are what gets allow-listed.
 */
export const sanitizeArticleHtml = (html?: string): string => DOMPurify.sanitize(html ?? "");
